import { render, staticRenderFns } from "./Sismografia.vue?vue&type=template&id=5b894989&scoped=true"
import script from "./Sismografia.vue?vue&type=script&lang=js"
export * from "./Sismografia.vue?vue&type=script&lang=js"
import style0 from "./Sismografia.vue?vue&type=style&index=0&id=5b894989&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b894989",
  null
  
)

export default component.exports